export default {
  layouts: {
    nasiya: {
      logout: 'Выйти',
      main: 'Главное',
      applications: 'Заявки',
      searchClients: 'Поиск клиента',
      rejects: 'Возвраты',
      tickets: 'Проблемные кейсы',
      deliveries: 'Доставки',
      management: 'Менеджмент',
      analytics: 'Аналитика',
      invoice: 'Счёт-фактура',
      sales: 'Продажи',
      excels: 'Отчёты',
      allApplications: 'Заявки всех магазинов',
      notifications: 'Уведомления',
      bonuses: 'Бонусы',
      installmentPayment: 'Оплата рассрочки',
      warehouse: 'Склад',
      shipmentOffers: 'Отгрузка товаров',
    },
  },
};
